import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { beneLookUp } from "../../../redux/features/verifyPAN/verifyPAN";

import { beneBankLookUp } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import FieldForceTxnDestAcc from "../FieldForceTxnDestAcc";
import CommonLayout from "../../_utils/CommonLayout";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";

const FieldForceCreateTxnSelectAccount = (props) => {
  const MIN_ASSOCIATES = GlobalConfiguration.lengthCheckOne;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const disableCategories = true;
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);
  const [bankLogo, setBankLogo] = useState(
    props?.txnPayLoad?.bankLogo ? props?.txnPayLoad?.bankLogo : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.txnPayLoad?.bankAccountNo ? props?.txnPayLoad?.bankAccountNo : "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );
  const [accountName, setAccountName] = useState(
    props?.txnPayLoad?.bankAccountName
      ? props?.txnPayLoad?.bankAccountName
      : "",
  );
  const [panNumber, setPanNumber] = useState(
    props?.txnPayLoad?.pan ? props?.txnPayLoad?.pan : null,
  );
  const [IFSC, setIFSC] = useState(
    props?.txnPayLoad?.bankAccountIFSC
      ? props?.txnPayLoad?.bankAccountIFSC
      : "",
  );

  const [activeType, setActiveType] = useState("pan");
  const [remPan, setRemPan] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [remIFSC, setRemIFSC] = useState("");

  const { beneSuccessData } = useSelector(
    (state) => state?.beneCreateAccountSlice,
  );
  const { beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const unassignCategories = props?.categories.filter(
    (cat) => cat?.active === "Y",
  );
  const unassignlength = unassignCategories.filter(
    (unassignCategory) => !props?.category?.includes(unassignCategory.name),
  );

  const { beneLookData } = useSelector((state) => state.verify);
  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > MIN_ASSOCIATES || havePANAssociate > MIN_ASSOCIATES) &&
    accountNumber &&
    IFSC;

  useEffect(() => {
    if (props?.associateModalOpen) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "auto";
    }
  }, [props?.associateModalOpen]);

  const handleUnassignNavigate = (id) => {
    toast.info("Feature coming soon", toast_position);
    // navigate(
    //   `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_category/${props.txnPayLoad.beneAccountId}`,
    // );
  };

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  useEffect(() => {
    setHaveBankAssociate(bankData?.total_count || 0);
    setHavePANAssociate(beneLookData?.total_count || 0);
  }, [beneLookData, bankData, dispatch]);

  useEffect(() => {
    dispatch(beneLookUp({ pan_number: props?.txnPayLoad?.pan }));
  }, [props?.txnPayLoad?.pan]);

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    setAccountName(accountName);
    setAccountNumber(accountNumber);
    setIFSC(ifsc);
    setBankLogo(bankLogo);
    setBeneAccountId(beneAccountId);
    setPanNumber(panNo);
    props?.setLabelsAcc(labels);

    const isRecreateFlow = props?.mapingData === "renderData";
    const isAccountChanged =
      props?.txnPayLoad?.beneAccountId &&
      props?.txnPayLoad?.beneAccountId !== beneAccountId;

    if (!isRecreateFlow || isAccountChanged) {
      props?.setSelectedCategory(null);
      props?.setCatShow(true);
      props?.setCatSelect(false);
    }

    dispatch(beneLookUp({ pan_number: panNo }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc,
        bank_account_no: accountNumber,
      }),
    );

    let matchedCategory = null;

    if (
      props?.type === "PayReimburseTxn" &&
      categoriesArray.length > GlobalConfiguration?.lengthCheckZero
    ) {
      props?.setSelectedCategory({
        name: categoriesArray[0],
        configuration: props?.categories?.find((cat) =>
          cat?.category_name
            ?.toLowerCase()
            .includes(categoriesArray[0].toLowerCase()),
        )?.configuration,
      });
    }

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      selectedCategory: matchedCategory ?? null,
      amountWords: "",
      mergeCategory: null,
    }));
    props?.setAmountInWords("");
    handleCloseModal();

    if (beneSuccessData?.beneficiary_accounts?.[0]?.id !== beneAccountId) {
      props?.setAccountSelect(false);
      props?.setCatShow(true);
    }
  };

  useEffect(() => {
    if (props?.mapingData === "renderData" && props?.accountSelect) {
      handleAccountSelection(
        beneSuccessData?.beneficiary_accounts?.[0]?.name,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_acc_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.ifsc_code,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_name,
        beneSuccessData?.beneficiary_accounts?.[0]?.category,
        beneSuccessData?.beneficiary_accounts?.[0]?.pan_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.id,
        beneSuccessData?.beneficiary_accounts?.[0]?.labels,
      );
      props?.setCatShow(true);
    }
  }, [props?.mapingData, props?.accountSelect]);

  const handleCategorySelect = (category) => {
    const categoryData = props?.categories.find(
      (cat) =>
        cat.name?.trim().toLowerCase() === category?.trim().toLowerCase(),
    );
    if (props?.selectedCategory?.name === category) {
      return;
    }
    if (props?.txnPayLoad?.selectedCategory?.name === props?.catName) {
      props?.setCatSelect(false);
    }
    props?.setSelectedCategory(categoryData);
    props?.handleCategorySelect(categoryData);
    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      selectedCategory: categoryData,
    });
    props?.setAdditionalData({});
    props?.setSelectedValue({ from: "Select", to: "Select" });
    props?.setDateRangeEnabled(false);
    props?.setShowDatePicker({});
    props?.setStartDate({});
    props?.setEndDate({});
    props?.setShowDatePickerCal({});
    props?.setStartDateCal({});
    props?.setIsSingleDateSelected(false);
    props?.setHyperLink({});
    props?.setPreviewImages({});
    props?.setUploadedFiles({});
    props?.setTimeData({});
    props?.setQuantities({});
    props?.setSelectedValueMonth({});
  };

  useEffect(() => {
    if (props?.mapingCat === "renderCat" && props?.catSelect) {
      handleCategorySelect(beneTxnAccountData?.transaction?.[0]?.category);
      props?.setMapingCat(null);
    }
  }, [props?.mapingCat, props?.catSelect]);

  return (
    <>
      <div className="w-width-full  Qlg:px-padding-base px-padding-md Qsmd:pt-padding-lg pt-padding-md">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={props?.openOwner}
              setModalOpen={props?.setOpenOwner}
              txnPayLoad={props?.txnPayLoad}
              setTxnPayLoad={props?.setTxnPayLoad}
              handleOnAccountSelection={handleOwnerSelection}
              TypeRTGS={props?.TypeRTGS}
              currentAccountDetails={props?.currentAccountDetails}
              isFieldforce={true}
            />
          </div>
          <div className="flex flex-col gap-gap-md">
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] ${
                props?.type === "PayReimburseTxn"
                  ? "opacity-light-opacity pointer-events-none"
                  : !props?.txnPayLoad?.ownerBankAccountNo
                    ? "opacity-light-opacity pointer-events-none"
                    : "opacity-base-opacity"
              }`}
            >
              <FieldForceTxnDestAcc
                type="destination"
                flow="beneficiary"
                modalOpen={props?.isModalOpen}
                setModalOpen={props?.setIsModalOpen}
                txnPayLoad={props.txnPayLoad}
                setTxnPayLoad={props.setTxnPayLoad}
                shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
                handleOnAccountSelection={handleAccountSelection}
                setActiveType={setActiveType}
              />
            </div>

            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] pb-padding-xl ${props?.type === "PayReimburseTxn" && "opacity-light-opacity pointer-events-none"}`}
            >
              <CategorySelector
                beneAccountId={beneAccountId}
                category={props?.category}
                selectedCategory={props?.selectedCategory}
                unassignCategories={unassignCategories}
                unassignlength={unassignlength}
                disableCategories={disableCategories}
                handleCategorySelect={handleCategorySelect}
                handleUnassignNavigate={handleUnassignNavigate}
                previewMode={false}
                variant={
                  props?.type === "PayReimburseTxn" ? "selected" : "list"
                }
                enableSearch
                showUnassignCTA={true}
              />
            </div>
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
      </div>
    </>
  );
};

export default FieldForceCreateTxnSelectAccount;
